import { DialogContent, DialogActions } from '@mui/material';
import { ThemeButton } from '@shared/ui/buttons';
import { CardsPreviewGroup } from '@shared/ui/parts';
import { useTranslation } from 'react-i18next';
import { useCards } from '@app/api/cards/useCards';
import { useState } from 'react';
import { cardStatuses } from '@utils/statuses';

export default function FreezeCardDialog({ close, data }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { freezeCards } = useCards();

  const availableCards = data.filter((item) => {
    const status = cardStatuses[item?.status];
    return status !== 'frozen' && status !== 'blocked';
  });

  async function onSubmit() {
    setIsLoading(true);
    try {
      const res = await freezeCards({
        card_ids: availableCards.map((x) => x.id),
      });
      if (res) close();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }
  return (
    <>
      <DialogContent>
        <CardsPreviewGroup
          data={availableCards}
          label={t('are_you_sure_freeze_cards')}
        />
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            startIcon="freeze"
            onClick={onSubmit}
            loading={isLoading}
          >
            {t('yes_freeze')}
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
